import apiInstance from './apiInstance';
import { handleUnauth } from './appService';

async function getArchivedOvApplications() {
  try {
    const res = await apiInstance.get(
      '/overlatelser/portal/applications/archive'
    );
    return res.data;
  } catch (error) {
    return handleUnauth(error);
  }
}
async function getUserOvApplications(userId, ovApplicationType) {
  try {
    const res = await apiInstance.get(
      `/overlatelser/portal/applications/history/${userId}/${ovApplicationType}`
    );
    return res.data;
  } catch (error) {
    return handleUnauth(error);
  }
}

async function getOvApplication(id, applicationType) {
  try {
    const res = await apiInstance.get(
      `/overlatelser/portal/applications/${id}?type=${applicationType}`
    );
    return res.data;
  } catch (error) {
    return handleUnauth(error);
  }
}
async function removeOvApplication(applicationId, reason = '') {
  try {
    const res = await apiInstance.post(
      `/overlatelser/portal/applications/${applicationId}/remove`,
      {
        reason
      }
    );
    return res.status === 200;
  } catch (error) {
    return null;
  }
}

async function abortOvApplication(applicationId, reason = '') {
  try {
    const res = await apiInstance.post(
      `/overlatelser/portal/applications/${applicationId}/abort`,
      {
        reason
      }
    );
    return res.status === 200;
  } catch (error) {
    return null;
  }
}

async function rejectOvApplication(applicationId, note) {
  try {
    const res = await apiInstance.post(
      `/overlatelser/portal/applications/${applicationId}/reject`,
      {
        note
      }
    );
    return res.status === 200;
  } catch (error) {
    return null;
  }
}

async function closeOvApplication(applicationId, note) {
  return await apiInstance.post(
    `/overlatelser/portal/applications/${applicationId}/close`,
    {
      note
    }
  );
}

async function approveOvApplication(applicationId) {
  try {
    const res = await apiInstance.post(
      `/overlatelser/portal/applications/${applicationId}/approve`
    );
    return res.status === 200;
  } catch (error) {
    return null;
  }
}

async function getOvApplications(type = 'ov-private') {
  try {
    const res = await apiInstance.get(
      `/overlatelser/portal/applications?type=${type}`
    );
    return res.data;
  } catch (error) {
    return handleUnauth(error);
  }
}

async function getOvFile(applicationId, uuid) {
  const { data } = await apiInstance.get(
    `/overlatelser/portal/documents/${applicationId}/${uuid}`,
    {
      responseType: 'blob'
    }
  );
  return data;
}

async function setOvTransferDate(applicationId, actualTransferDate) {
  const res = await apiInstance.put(
    `/overlatelser/portal/applications/${applicationId}/transferDate`,
    {
      actualTransferDate
    }
  );
  return res;
}

export {
  getArchivedOvApplications,
  getUserOvApplications,
  getOvApplication,
  removeOvApplication,
  abortOvApplication,
  rejectOvApplication,
  closeOvApplication,
  approveOvApplication,
  getOvApplications,
  getOvFile,
  setOvTransferDate
};
